export const selectAffiliate_actionType = {
    SET_SELECT_AFFILIATE_SUCCESS : 'SET_SELECT_AFFILIATE_SUCCESS',
    SET_SELECT_AFFILIATE_FAILURE : 'SET_SELECT_AFFILIATE_FAILURE',
    GET_SELECT_AFFILIATE_SUCCESS : 'GET_SELECT_AFFILIATE_SUCCESS',
    GET_SELECT_AFFILIATE_FAILURE : 'GET_SELECT_AFFILIATE_FAILURE',
    RESET_SELECT_AFFILIATE_SUCCESS: 'RESET_SELECT_AFFILIATE_SUCCESS'
};